// IMPORT
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import 'url-search-params-polyfill'
var messages = require('./messages')
Vue.use(VueI18n)

// to use a copydeck.......
// let copydeck = require('./process.messages').default
// console.log(copydeck)

// GET LANG
let defaultLocale = 'cn'
// if (navigator.language.indexOf('en') >= 0) defaultLocale = 'en' // auto switch lang by browser
// defaultLocale = 'cn' // DEBUG

let urlParams = new window.URLSearchParams(window.location.search)
let locale = urlParams.get('_locale') || defaultLocale

// INIT
export const i18n = new VueI18n({
  locale: locale,
  messages,
})

// UPDATE SITE TITLE
if (locale !== 'cn') document.title = i18n.t('page_title')

// EXPORT
export default i18n
window.i18n = i18n
